import * as React from 'react';

export default function QuickLoginIcon({
  className,
  pathClassName,
}: {
  className?: string;
  pathClassName?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="#fff"
      className={className}
    >
      <path
        d="M17.5 2a2 2 0 0 1 2 2v6.674a6.95 6.95 0 0 0-1.5-.513V4a.5.5 0 0 0-.5-.5h-12A.5.5 0 0 0 5 4v11.25h4.721a7 7 0 0 0-.217 1.5H5V20a.5.5 0 0 0 .5.5h4.937c.319.552.712 1.057 1.164 1.5H5.5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12zm-.97 17.53l3.5-3.5-1.061-1.061-2.97 2.97-1.97-1.97-1.061 1.061 2.5 2.5a.75.75 0 0 0 1.061 0z"
        className={pathClassName}
      />
      <path
        fillRule="evenodd"
        d="M22.5 17a6 6 0 1 1-12 0 6 6 0 1 1 12 0zM21 17a4.5 4.5 0 1 1-9 0 4.5 4.5 0 1 1 9 0z"
        className={pathClassName}
      />
    </svg>
  );
}
